<template>
  <div :class="wrapperClass">
    <label class="form-label">{{ label }}</label>
    <component
      :is="isTextarea ? 'textarea' : 'input'"
      :rows="rows"
      :type="isTextarea ? undefined : type"
      :value="modelValue"
      :placeholder="placeholder"
      class="form-control form-control-sm"
      :class="{ 'is-invalid': !!error }"
      @input="$emit('update:modelValue', $event.target.value)"
    ></component>
    <div v-if="error" class="invalid-feedback d-block">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'WpFieldInput',
  props: {
    modelValue: { type: [String, Number], default: '' },
    label: { type: String, required: true },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' },
    rows: { type: Number, default: 3 },
    wrapperClass: { type: String, default: 'col-md-6' },
    error: { type: String, default: '' },
    isTextarea: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
}
</script>
